export default {
  methods: {
    answer (session) { session.answer() }
  }
}
